import React, { useContext, useState } from 'react';
import { Button, Col, Divider, Form, Input, Radio, Row } from 'antd';
import PropTypes from 'prop-types';
import DeleteButton from '../../../../../../../../../components/common/buttons/DeleteButton';
import AloneCol from '../../../../../../../../../components/common/AloneCol';
import InputNumber from '../../../../../../../../../components/form/inputs/InputNumber';
import IdentificationType from '../../../../../../../../../enums/identificationType';
import InputRut from '../../../../../../../../../components/form/inputs/InputRut';
import InputGeo from '../../../../../../../../../components/common/inputs/InputGeo';
import { EnrollmentFormContext } from '../../../../../../../../../providers/EnrollmentFormContextProvider';
import { rutValidator } from '../../../../../../../../../utils/validators';

const DataForm = ({ gutter }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [selectedRut, setSelectedRut] = useState([]);

  const toggleRutCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = true;
    setSelectedRut(arr);

    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.effectiveControllers[key], {
      identification: '',
      identificationType: IdentificationType.RUT,
    });
    enrollmentForm.setFieldsValue(formValues);
  };

  const togglePassportCheck = (key) => {
    const arr = [...selectedRut];
    arr[key] = false;
    setSelectedRut(arr);
    const formValues = enrollmentForm.getFieldsValue(true);
    Object.assign(formValues.effectiveControllers[key], {
      identification: '',
      identificationType: IdentificationType.PASAPORTE,
    });
    enrollmentForm.setFieldsValue(formValues);
    enrollmentForm.validateFields([['effectiveControllers', key, 'identification']]);
  };
  // TODO: Eliminar si hay datos precargados
  const initialValues = {
    effectiveControllers: [{}],
  };

  return (
    <>
      <Form form={enrollmentForm} layout="vertical" initialValues={initialValues}>
        <Form.List name="effectiveControllers">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                <React.Fragment key={key}>
                  {index > 0 && <Divider />}
                  <Row gutter={[gutter]}>
                    <Col span={24}>
                      <Form.Item
                        name={[name, 'identificationType']}
                        rules={[{ required: true }]}
                        {...restField}
                      >
                        <Radio.Group defaultValue={1}>
                          <Radio
                            value={IdentificationType.RUT}
                            onChange={() => toggleRutCheck(key)}
                          >
                            Rut
                          </Radio>
                          <Radio
                            value={IdentificationType.PASAPORTE}
                            onChange={() => togglePassportCheck(key)}
                          >
                            Pasaporte
                          </Radio>
                          <Radio
                            value={IdentificationType.OTRO}
                            onChange={() => togglePassportCheck(key)}
                          >
                            Otro
                          </Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                    <Col lg={{ span: 12 }} xs={24}>
                      <Form.Item shouldUpdate noStyle>
                        {() => (
                          <Form.Item
                            label="N° de Identificación"
                            name={[name, 'identification']}
                            fieldKey={[fieldKey, 'identification']}
                            rules={[
                              {
                                required: true,
                                message: 'Identificador Requerido',
                              },
                              {
                                validator: selectedRut[key] ? rutValidator : undefined,
                                message: 'Rut invalido ',
                              },
                            ]}
                          >
                            {selectedRut[key] ? <InputRut /> : <Input type="text" maxLength={12} />}
                          </Form.Item>
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        fieldKey={[fieldKey, 'name']}
                        name={[name, 'name']}
                        label="Nombre"
                        rules={[
                          {
                            required: true,
                            message: 'Dato es requerido',
                          },
                        ]}
                        {...restField}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        fieldKey={[fieldKey, 'firstSurname']}
                        name={[name, 'firstSurname']}
                        label="Apellido Paterno"
                        rules={[
                          {
                            required: true,
                            message: 'Dato es requerido',
                          },
                        ]}
                        {...restField}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        fieldKey={[fieldKey, 'secondSurname']}
                        name={[name, 'secondSurname']}
                        label="Apellido Materno"
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                        {...restField}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <AloneCol lg={24} xs={24}>
                      <InputGeo
                        form={enrollmentForm}
                        countryName={[name, 'address', 'country']}
                        regionName={[name, 'address', 'region']}
                        cityName={[name, 'address', 'city']}
                      />
                    </AloneCol>
                    <Col span={12}>
                      <Form.Item
                        fieldKey={[fieldKey, 'address', 'streetName']}
                        name={[name, 'address', 'streetName']}
                        label="Calle/Avenida"
                        rules={[
                          {
                            required: true,
                            message: 'Dato requerido',
                          },
                        ]}
                        {...restField}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        fieldKey={[fieldKey, 'address', 'streetNumber']}
                        name={[name, 'address', 'streetNumber']}
                        label="Número"
                        rules={[
                          {
                            required: true,
                            message: 'Dato requerido',
                          },
                        ]}
                        {...restField}
                      >
                        <InputNumber hideArrows />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        fieldKey={[fieldKey, 'address', 'houseNumber']}
                        name={[name, 'address', 'houseNumber']}
                        label="Depto/Casa"
                        {...restField}
                      >
                        <Input />
                      </Form.Item>
                    </Col>
                    <AloneCol span={12}>
                      <Form.Item
                        fieldKey={[fieldKey, 'participation']}
                        name={[name, 'participation']}
                        label="% Participación en la persona declarante"
                        rules={[
                          {
                            required: true,
                            message: 'Campo requerido',
                          },
                          {
                            type: 'number',
                            max: 10,
                            message: 'Solo personas con menos del 10%',
                          },
                        ]}
                        {...restField}
                      >
                        <InputNumber hideArrows />
                      </Form.Item>
                    </AloneCol>
                    <AloneCol lg={12} xs={24}>
                      <Form.Item>
                        <DeleteButton onClick={() => remove(name)}>Eliminar Persona</DeleteButton>
                      </Form.Item>
                    </AloneCol>
                  </Row>
                </React.Fragment>
              ))}
              {fields.length < 3 && (
                <Form.Item>
                  <Button type="dashed" onClick={() => add({})} block>
                    + Agregar persona
                  </Button>
                </Form.Item>
              )}
            </>
          )}
        </Form.List>
      </Form>
    </>
  );
};

DataForm.propTypes = {
  gutter: PropTypes.number.isRequired,
};

export default DataForm;
